var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('report-table',{on:{"click-report":_vm.onReportClick}}),_c('view-report',{attrs:{"reportId":_vm.selectedReportId},model:{value:(_vm.showReport),callback:function ($$v) {_vm.showReport=$$v},expression:"showReport"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }